import { createSelector } from '@ngrx/store';
import { mcpAccessAdapter, mcpAccessFeature } from './mcp-access.reducer';

export const {
  selectAdminMcpAccessState,
  selectTotal: selectMcpAccessTotal,
  selectQuery: selectMcpAccessQuery,
  selectLoading: selectMcpAccessLoading,
  selectCreating: selectMcpAccessCreating,
  selectMutatingId: selectMcpAccessMutatingId,
  selectError: selectMcpAccessError,
} = mcpAccessFeature;

const entitySelectors = mcpAccessAdapter.getSelectors(selectAdminMcpAccessState);
export const selectAllMcpAccessGrants = entitySelectors.selectAll;

export const selectMcpAccessPage = createSelector(selectMcpAccessQuery, (q) => q.page);
export const selectMcpAccessLimit = createSelector(selectMcpAccessQuery, (q) => q.limit);
